<template>
    <div class="flex max-h-80 flex-col gap-3 overflow-y-auto focus-ring" role="region" aria-label="Evidence details" tabindex="0">
        <section v-for="group in groups" :key="group.kind" class="flex flex-col gap-2">
            <h4 class="flex items-center gap-2 body-small-bold text-ink">
                <EvidenceSourceIcon :kind="group.kind" />
                {{ group.label }}
            </h4>
            <ul class="flex flex-col gap-1">
                <li v-for="(item, index) in group.items" :key="`${item.label}-${index}`">
                    <a
                        v-if="item.href"
                        :href="item.href"
                        target="_blank"
                        rel="noopener noreferrer"
                        class="group/item flex items-start justify-between gap-2 rounded-md px-2 py-2 text-left hover:bg-surface-hover focus-ring"
                        @click="emit('evidence-link-clicked', group, item)">
                        <span class="min-w-0">
                            <span class="block truncate body-small text-ink">{{ item.label }}</span>
                            <span v-if="item.detail" class="block truncate scaffold-details-small text-ink-muted">{{ evidenceDetail(group, item) }}</span>
                        </span>
                        <i class="bi bi-box-arrow-up-right mt-1 shrink-0 text-ink-muted" aria-hidden="true"></i>
                    </a>
                    <div v-else class="px-2 py-2">
                        <span class="block body-small text-ink">{{ item.label }}</span>
                        <span v-if="item.detail" class="block scaffold-details-small text-ink-muted">{{ evidenceDetail(group, item) }}</span>
                    </div>
                </li>
            </ul>
        </section>
    </div>
</template>

<script setup lang="ts">
import type { InsightEvidenceGroup, InsightEvidenceItem } from "~vue/Labs/evidence";
import EvidenceSourceIcon from "~vue/Labs/EvidenceSourceIcon.vue";
import { useI18n } from "vue-i18n";

defineProps<{ groups: InsightEvidenceGroup[] }>();
const emit = defineEmits<{ "evidence-link-clicked": [group: InsightEvidenceGroup, item: InsightEvidenceItem] }>();
const { t } = useI18n();

function evidenceDetail(group: InsightEvidenceGroup, item: InsightEvidenceItem): string {
    return group.kind === "user_profile_note" ? t("labs.evidence.profileNoteDetail") : (item.detail ?? "");
}
</script>
